import React, { useEffect, useState } from 'react'
import { IInputProps } from '../../../types/interfaces/IInputProps'
import { IdentityProviderInputContainer, OptionsWrapper } from './style'
import RadioButton from '../radio-button/RadioButton'
import { useTranslation } from 'react-i18next'
import { IdInput } from '../id-input/IdInput'
import { IdentityProvider } from 'types/types/IdentityProvider'
import { FormTypes } from 'types/enums/EFormTypes'
import { PassportInput } from '../passport-input/PassportInput'

interface IIdentityProviderInputProps extends IInputProps {
  identityValue: IdentityProvider
  identityCallback: (
    value: IdentityProvider,
    error?: boolean | undefined,
  ) => void
  form: FormTypes
}

export const IdentityProviderInput: React.FC<IIdentityProviderInputProps> = ({
  callback,
  value,
  hasError,
  className,
  form,
  identityCallback,
  identityValue,
}) => {
  const [selected, setSelected] = useState(identityValue)

  const { t } = useTranslation('', {
    keyPrefix: `pages.${form}.identityProvider`,
  })

  useEffect(() => {}, [t])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const identityProvider = e.target.value as IdentityProvider
    setSelected(identityProvider)
    identityCallback(identityProvider, false)
  }

  return (
    <>
      <IdentityProviderInputContainer
        className={className ?? 'identityProvider'}
      >
        <OptionsWrapper>
          <RadioButton
            id={'id'}
            label={t('id.labelText')}
            value={'id'}
            isSelected={selected === 'id'}
            callback={handleChange}
          ></RadioButton>
          <RadioButton
            id={'passport'}
            label={t('passport.labelText')}
            value={'passport'}
            isSelected={selected === 'passport'}
            callback={handleChange}
          ></RadioButton>
        </OptionsWrapper>
      </IdentityProviderInputContainer>
      {identityValue === 'id' ? (
        <IdInput
          hasError={hasError}
          labelText={t(`inputs.${selected}.labelText`)}
          errorText={t(`inputs.${selected}.errorText`)}
          callback={callback}
          value={value}
        ></IdInput>
      ) : identityValue === 'passport' ? (
        <PassportInput
          hasError={hasError}
          labelText={t(`inputs.${selected}.labelText`)}
          errorText={t(`inputs.${selected}.errorText`)}
          callback={callback}
          value={value}
        ></PassportInput>
      ) : (
        <></>
      )}
    </>
  )
}
